const TRAFFIC_STORAGE_KEY = 'trafficInfo';
const VALID_TRAFFIC_TYPES = ['organic', 'paid'];
const CLICK_ID_KEYS = ['gclid', 'msclkid'];

function getTrafficTypeFromRequestVariables() {
  const trafficType = window.requestVariables && window.requestVariables.traffic_type;

  if (VALID_TRAFFIC_TYPES.includes(trafficType)) {
    return trafficType;
  }

  return 'organic';
}

function getSearchParams() {
  return new URLSearchParams(window.location.search);
}

function getClickIds() {
  const params = getSearchParams();
  const requestVariables = window.requestVariables || {};
  const clickIds = {};

  CLICK_ID_KEYS.forEach((key) => {
    const value = params.get(key) || requestVariables[key];
    if (value) {
      clickIds[key] = value;
    }
  });

  return clickIds;
}

function readStored() {
  try {
    return JSON.parse(sessionStorage.getItem(TRAFFIC_STORAGE_KEY) || '{}');
  } catch (e) {
    return {};
  }
}

export function captureTrafficAttribution() {
  const stored = readStored();
  const clickIds = getClickIds();
  const trafficInfo = {
    traffic_type: stored.traffic_type || getTrafficTypeFromRequestVariables(),
  };

  CLICK_ID_KEYS.forEach((key) => {
    if (stored[key]) {
      trafficInfo[key] = stored[key];
    } else if (clickIds[key]) {
      trafficInfo[key] = clickIds[key];
    }
  });

  sessionStorage.setItem(TRAFFIC_STORAGE_KEY, JSON.stringify(trafficInfo));

  return trafficInfo;
}

export function getTrafficFields() {
  return captureTrafficAttribution();
}
